export default {
  OPERACION_DETALLE: (state, mutation) => {
    state.operacion = mutation.oper
    state.id = mutation.id
  },
}
